import { render, staticRenderFns } from "./EditionLabel.vue?vue&type=template&id=434ec156&"
import script from "./EditionLabel.vue?vue&type=script&lang=js&"
export * from "./EditionLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports